import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function managementComments(uid, searchKey, nextUrl) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        nextUrl
          ? nextUrl.replace("http:", "https:")
          : `${config.baseUrl}v1/socials/comments?location=${uid}&q=${searchKey}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { managementComments };
